<template>
    <div class="container">
        <div class="flex-wrapper">
            <div class="section">
                <h1>1. Take Survey</h1>
                <p>
                    Teachers take a diagnostic covering six online domains: Instruction, Professional Responsibilities, Technology, Planning & Preparation, Curriculum and Instructional Design.
                </p>
            </div>
            <div class="section">
                <h1>2. Get Feedback</h1>
                <p>
                    Every teacher receives immediate and personalized feedback, providing a valuable assessment of online instruction and pedagogy.
                </p>
            </div>
            <div class="section">
                <h1>3. Get reporting</h1>
                <p>
                    Administrators empowered with reporting that may be used to drive PD, make funding decisions or simply assess readiness for online learning.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    "name": "home-section-4",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    width: 90vw;
    margin-bottom: 75px;

}

.flex-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 50px;
    
    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 5%; 
        margin-right: 5%; 
    }
}

.section{

    border: 2px solid #662d91;
    border-radius: 10px;
    padding: 1%;
    margin-bottom: 50px;

    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 1%; 
        margin-right: 1%; 
    }


    h1{
        text-transform: uppercase;
        color: #662d91;
        font-size: 1.1rem;
    }
}

</style>